module.exports = __webpack_public_path__ + "img/WAXING_CRESCENT.10a78d09.png";